<div class="modal-header">
  <h5 class="modal-title">Attention! Impossible de faire cette action pendant que le calcul est en cours.</h5>
</div>
<div class="modal-body">
  <p>Il impossible d'effectuer cette action pendant que le calcul est en cours.</p>
</div>
<div class="modal-footer">
  <button (click)="activeModal.close(false)" class="btn btn-primary" data-bs-dismiss="modal" type="button">Ok</button>
</div>
